var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIntlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#008577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7148 8.27734L18.9062 9.05078L10.3633 17.1719L9.58984 17.9102L8.81641 17.1719L4.80859 13.375L4 12.6016L5.54688 10.9844L6.35547 11.7578L9.58984 14.7812L17.3594 7.39844L18.168 6.625L19.7148 8.27734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIntlLogo);
export default __webpack_public_path__ + "static/media/checkMarkIntlLogo.55a5aa5da31f058102fb2172fc5d0e28.svg";
export { ForwardRef as ReactComponent };